namespace Areas.OneTimeUploads {
    "use strict";

    //
    //CRUD functions
    //

    export function insertRecord(e) {
        const form = Areas.getForm("OneTimeUploadForm");
        const newData: any = form.option('formData');
        const result: any = form.validate();

        removeUtcDesignation(newData, "DateToSendEmail");

        if (result.isValid) {
            Areas.sendRequest("/OneTimeUploads/Create/Post", JSON.stringify(newData), "POST");
        }
    }

    function removeUtcDesignation(newData: any, dateProperty: string) {
        newData[dateProperty] = newData[dateProperty] ? newData[dateProperty].toLocaleString() : null;
    }

    export function updateRecord(e) {
        const form = Areas.getForm("OneTimeUploadForm");
        const newData: any = form.option('formData');
        const result: any = form.validate();
        const keyId: any = form.option('KeyId');

        removeUtcDesignation(newData, "DateToSendEmail");

        if (result.isValid && keyId != null) {
            Areas.sendRequest(`/OneTimeUploads/Edit/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function deleteRecord() {
        var verifyVOID = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVOID = true) {
            var keyId: any = Areas.getOptionFromForm("OneTimeUploadForm", "KeyId");

            if (keyId != null) {
                Areas.sendRequest(`/OneTimeUploads/Edit/Delete/${keyId}`, null, "DELETE");
            }
            else {
                DevExpress.ui.notify("Invalid Record.", "warning", 2000);
            }
        }
   }

    export function processFTP(e) {
        var verifyProcessFtp = window.confirm("Are you sure you would like to Process this to FTP?");

        if (verifyProcessFtp == true) {
            var keyId: any = Areas.getOptionFromForm("OneTimeUploadForm", "KeyId");

            if (keyId != null) {
                Areas.sendRequest(`/OneTimeUploads/Edit/ProcessFtp/${keyId}`, null, "PUT");
            }
            else {
                DevExpress.ui.notify("Invalid Record.", "warning", 2000);
            }
        }
   }
}
